import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  computed: {
    ...mapGetters({
      checkoutPaymentMethods: 'checkout/paymentMethods',
      checkoutShippingMethods: 'checkout/shippingMethods',
      checkoutShippingAddress: 'checkout/shippingAddress',
    }),
  },
  methods: {
    getPickupPointAddressById(id) {
      return _.find(
        this.checkoutShippingAddress.PickupPoints,
        (point) => point.Address.Id === id,
      );
    },
    ...mapActions({
      fetchShippingAddress: 'checkout/fetchShippingAddress',
      fetchShippingMethods: 'checkout/fetchShippingMethods',
      fetchPaymentMethods: 'checkout/fetchPaymentMethods',
      confirmCheckout: 'checkout/confirmCheckout',
    }),
  },
};
